// extracted by mini-css-extract-plugin
export default {"caution_300":"#ffc37d","tabFocusedBorder":"style_tabFocusedBorder__GQikO","mouseFocusedBorder":"style_mouseFocusedBorder__A2M7w"};